<template>
  <div
    id="pano"
    style="width: 100%; height: 100%"
    class="img-fluid shadow"
  ></div>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    gameID: String,
    pano: String
  },
  created() {
    this.$loadScript('/krpano/krpano.js').then(() => {
      this.loadPano()
    })
  },
  methods: {
    loadPano() {
      let panoURL =
        process.env.VUE_APP_API_BASE_URL +
        '/../assets/' +
        this.gameID +
        '/krpano/' +
        this.pano +
        '.xml'

      /*global embedpano*/
      /*eslint no-undef: "error"*/
      embedpano({
        swf: 'krpano.swf',
        xml: panoURL,
        basepath: location.origin + '/krpano/',
        target: 'pano',
        id: this.pano
      })
    }
  },
  watch: {
    pano: function(newVal, oldVal) {
      /*global removepano*/
      /*eslint no-undef: "error"*/
      removepano(oldVal)

      this.$nextTick(function() {
        this.loadPano()
      })
    }
  }
}
</script>

<style scoped></style>
